<template>
  <div class="tab-body">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="120px">
        <el-row>
          <el-col :span="3">
            <el-switch @change="clearSearchVal" v-model="swc" active-text="按姓名" inactive-text="按学校">
            </el-switch>
          </el-col>
          <el-col :span="3">
            <el-form-item size="mini" :label="swc ? '学生姓名' : '毕业学校'">
              <el-input v-if="swc" size="mini" v-model="searchParams.name"></el-input>
              <el-input v-else size="mini" v-model="searchParams.school"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item size="mini" :label="swc ? '手机' : '专业'">
              <el-input v-if="swc" size="mini" placeholder="完整手机号精确查找,空白输null" v-model="searchParams.mobile"></el-input>
              <el-input v-else size="mini" v-model="searchParams.subject"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item size="mini" label="跟进截止">
              <el-date-picker v-model="searchParams.lastgj" placeholder="查询之前记录" value-format="yyyy-MM-dd" type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <div class="search-btn">
            <el-button size="mini" type="primary" @click="search">搜索</el-button>
            <el-button size="mini" @click="clearSearchVal">重置</el-button>
          </div>
        </el-row>
      </el-form>
    </div>
    <div class="operator">
      <el-row>
        <el-col style="display: flex">
          <el-button type="primary" size="small" v-has-permission-code-and="'100000150000'"
            @click="toSave()">添加</el-button>
          <el-button type="success" size="small" @click="list">刷新</el-button>
          <el-button type="warning" size="small" v-has-permission-code-and="'100000150095'"
            @click="toPush()">导入</el-button>
          <el-button v-has-permission-code-and="'100000150030'" @click="dis2dy('分发电邀权限')" type="success" plain
            size="small" round>分派电邀</el-button>
          <el-button v-has-permission-code-and="'100000150040'" @click="dis2dy('分发咨询权限')" type="primary" plain
            size="small" round>分派咨询</el-button>
          <el-button v-has-permission-code-and="'100000150035'" @click="dis2dy('分发技术支持权限')" type="danger" size="small"
            round plain>分派技术</el-button>
          <!--el-button v-has-permission-code-and="'1000001禁止50045'" @click="phoneTo()" type="warning" size="small" plain
                round>批量电邀</el-button-->
          <!--el-button v-has-permission-code-and="'100000150026'" @click="attackTo()" type="info" size="small" plain
                round>批量跟进</el-button-->&nbsp;&nbsp;
          <div style="display: flex">

            <el-select size="mini" style="width: 110px" v-model="chs_post" @change="list" placeholder="按岗位查看">
              <el-option v-for="item in ['全部岗位', '前端', '后端', '全栈',  '其他']" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>&nbsp;&nbsp;
            <el-select size="mini" style="width: 160px" v-model="chs_opt" @change="chgSelect">
              <el-option v-for="item in statelist" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>&nbsp;&nbsp;
            <el-select size="mini" style="width: 110px" v-show=" !(me.role2=='zx1' && chs_zx =='未分配')   " v-model="chs_rank" @change="list" placeholder="按评级查看">
              <el-option v-for="item in [
        { nm: '全评级', val: -1 },
        { nm: '未评级', val: 0 },
        { nm: 'A量', val: 4 },
        { nm: 'B量', val: 3 },
        { nm: 'C量', val: 2 },
        { nm: 'D量', val: 1 },
      ]" :key="item.nm" :label="item.nm" :value="item.val">
              </el-option>
            </el-select>&nbsp;&nbsp;
            <el-select size="mini" style="width: 110px" v-has-permission-code-and="'100000150050'" @change="list"
              v-model="chs_zx" placeholder="按跟进员查看">
              <el-option v-for="item in zxs" :key="item.name" :label="item.name" :value="item.name">
              </el-option>
            </el-select>&nbsp;&nbsp;
            <el-select size="mini" style="width: 110px" v-has-permission-code-and="'10000015005x'" @change="list"
              v-model="chs_zstype" placeholder="渠道类型">
              <el-option v-for="item in [
        '全部渠道',
        '推广',
        '校招',
        '实训',
        '转介绍',
        '线上',
        '自招',
      ]" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
            &nbsp;&nbsp;
            <el-select size="mini" style="width: 110px" v-model="chs_grade" @change="chgGradeSelect"
              placeholder="按学历查看">
              <el-option v-for="item in ['全部学历', '本科', '大专', '未定义', '高学历', '低学历', '挑低学历']" :key="item" :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <el-button @click="showResume" v-has-permission-code-and="'1000001501333'" type="info" plain size="small"
            round>扫描1天内简历</el-button>

          <el-button @click="toTop" v-has-permission-code-and="'100000150082'" type="warning" size="small"
            round>手动置顶</el-button>

          <el-button @click="showConsudoc" v-has-permission-code-and="'1000001501335'" type="danger" size="small"
            round>招生备忘</el-button>&nbsp;&nbsp;

           <el-checkbox v-model="isLinqi" title="超21天不咨询跟进将被重置到公海"  @change="list">即将过期</el-checkbox>

          <el-button @click="merge21st" v-if="searchParams.mobile && selectedDatas.length > 1"
            v-has-permission-code-and="'1000001501350'" type="success" size="small" round>保留第一个</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table class="table" :data="listData.records" align="center" :header-cell-style="{ 'text-align': 'center' }"
        height="auto" @selection-change="selectionChange" v-loading="listLoading">
        <el-table-column type="selection" width="55px" fixed="left"></el-table-column>
        <el-table-column fixed="left" width="150px" prop="name" label="姓名">
          <template slot-scope="scope">
            <el-tag type="danger" :title="'女'" size="medium" v-if="scope.row.sex == '女'"> {{ scope.row.name }}</el-tag>
            <el-tag type="primary" :title="'男'" size="medium" v-else> {{ scope.row.name }}</el-tag>
            <el-image v-has-permission-code-and="'1000001501345'" title="有时看不见点要点多几次" v-if="scope.row.hasresume"
              style="width:30px; height: 20px" :src="'/static/shresume.png'"
              :preview-src-list="[(baseUrl + '/statics/resume24364/' + scope.row.mobile + '.jpg?' + Math.random())]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column fixed="left" width="75px" prop="name" label="意向">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.post == '全栈'" type="danger" effect="plain" size="mini">{{ scope.row.post }}</el-tag>
            <el-tag v-else-if="scope.row.post == '后端'" type="success" effect="plain" size="mini">{{ scope.row.post
              }}</el-tag>
            <el-tag v-else-if="scope.row.post == '前端'" type="warning" effect="plain" size="mini">{{ scope.row.post
              }}</el-tag>
            <el-tag v-else type="info" effect="plain" size="mini">{{ scope.row.post ? scope.row.post : '其他' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column width="120px" prop="mobile" label="手机">
          <template slot-scope="scope">
            <div v-if="me.role != 'dy' || (me.role == 'dy' && chs_zx == me.name)">
              {{ scope.row.mobile }}
            </div>
            <div v-else>
              待分配
            </div>
          </template>
        </el-table-column>
        <el-table-column width="240px" prop="schoolid" label="学历信息">
          <template slot-scope="scope">
            {{ scope.row.schoolid }} <br>
            <el-tag type="info" effect="plain" size="mini"> {{ scope.row.subject }} {{ scope.row.grade }} | {{
        scope.row.gradedate }}</el-tag>

          </template>
        </el-table-column>
        <el-table-column width="70px" prop="type" label="渠道">
          <template slot-scope="scope">
            <el-tag size="mini">{{ scope.row.type }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column v-if="me.role != 'zx' || me.role2 == 'zxm'" width="75px" prop="dyer" label="电邀">
          <template slot-scope="scope">
            <el-tag type="info" size="mini" effect="plain" v-if="scope.row.dyer"> {{ scope.row.dyer }} </el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="me.role2 == 'dy4' || me.role != 'dy'" width="75px" prop="dyer" label="咨询">
          <template slot-scope="scope">
            <el-tag size="mini" effect="plain" v-if="scope.row.zxer"> {{ scope.row.zxer }} </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="invitetime" width="135px" label="电邀/已上门">
          <template slot-scope="scope">
            <el-tag type="success" :title="scope.row.interviewtime" v-if="scope.row.interviewtime"
              size="mini">已上门</el-tag>
            <el-tag type="warning" :title="scope.row.invitetime" v-if="scope.row.invitetime" size="mini">已测评</el-tag>
            <el-tag type="danger" v-if="scope.row.present" size="mini">已辅助</el-tag>
          </template>
        </el-table-column>
        <el-table-column width="60px" prop="rank" label="评级">
          <template slot-scope="scope">
            <el-tag type="danger" size="mini" v-if="scope.row.rank == 1">D量</el-tag>
            <el-tag type="warning" size="mini" v-if="scope.row.rank == 2">C量</el-tag>
            <el-tag size="mini" v-if="scope.row.rank == 3">B量</el-tag>
            <el-tag type="success" size="mini" v-if="scope.row.rank == 4">A量</el-tag>
          </template>
        </el-table-column>
        <el-table-column width="120px" prop="crer" label="最后跟进">
          <template slot-scope="scope">
            <span v-if="me.role == 'ad' || me.role == 'mg' || scope.row.dbColumn_mder == me.name">{{
        scope.row.dbColumn_mder }}</span>
            <div>{{ scope.row.mdtm }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="sex" label="信息">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.state" size="mini">{{ scope.row.state }}</el-tag>
            <el-tag type="primary" v-if="scope.row.age" size="mini"> {{ calAge(scope.row.age) }}</el-tag>
            <el-tag type="success" v-if="scope.row.city" size="mini">{{ scope.row.city }}</el-tag>
            <br>
            <span v-if="scope.row.img">
              <el-tag type="info" v-if="me.role != 'dy'" :title="scope.row.img" size="mini">{{ scope.row.gjuser
                }}~{{ scope.row.img }}</el-tag>
              <el-tag type="info" v-else-if="me.role == 'dy'" :title="scope.row.img" size="mini">{{ scope.row.img
                }}</el-tag>
            </span>


          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" width="220px">
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button v-has-permission-code-and="'100000150005'" size="mini" type="text"
                @click="toDetail(scope.$index)">详情</el-button>
              <el-button type="text" @click="attackTo(scope.$index)" size="mini">跟进</el-button>
              <el-button title="跟进时根据实际情况修正咨询量信息" type="text" v-has-permission-code-and="'1000001501340'"
                @click="toUpdate(scope.$index, scope.row)" size="mini">修正</el-button>
              <el-button type="text" v-has-permission-code-and="'100000150015'" v-show="showEdit(scope.row.zxer)"
                @click="remove(scope.$index, scope.row)" size="mini">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBar">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total" :page-size="10"
          :current-page="page.current" :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"></el-pagination>
      </div>
    </div>
    <edit ref="edit" @flush="list()"></edit>
    <d2dy ref="d2dy" @flush="list()"></d2dy>
    <show ref="show" @flush="list()"></show>
    <uploaddist ref="uploaddist" @flush="list()"></uploaddist>
    <attckone ref="attckone" @flush="list()"></attckone>
    <consudoc ref="consudoc" @flush="list()"></consudoc>

    <el-dialog title="批量上传咨询数据" :visible.sync="dialogVisible" width="25%" :before-close="handleClose" :modal="false">
      <el-tag>
        <i class="el-icon-download" />
        <a :href="'/static/template.xlsx'">点击下载数据模版</a> </el-tag><br /><br />
      <span>拖拽excel文件到此上传:</span>
      <excel-Upload drag v-model="excel" size="2048" model="fileSystem" uri="/statics/excels"
        v-on:change="uploadSuccess"></excel-Upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

import d2dy from "./dispatch2dy.vue";
import attckone from "./attackone.vue";

import edit from "./edit.vue";
import show from "./show.vue";
import consudoc from "./consudoc.vue";
import api from "@/api/consu/consultation/consultation.js";
import excelUpload from "@/components/biz/fileUpload/excelUpload.vue";
import uploaddist from "./upload_dist.vue";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import constant from "@/util/constant.js";

export default {
  name: "consultation",
  components: {
    edit,
    d2dy,
    show,
    attckone,
    consudoc,
    excelUpload,
    uploaddist,
    selectOptionDictionary,
  },
  watch: {
    "searchParams.post": {
      handler() {
        if (this.searchParams.post) {
          this.searchParams.name = null;
          this.searchParams.mobile = null;
        }
      },
    },
    "searchParams.zx": {
      handler() {
        if (this.searchParams.zx) {
          this.searchParams.name = null;
          this.searchParams.mobile = null;
        }
      },
    },
  },
  data() {
    return {
      baseUrl: constant.serverUrl,
      searchParams: {},
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      selected: [],
      selectedDatas: [],
      now: {},
      users: [],
      isLinqi: false, //查临期
      zxs: [],
      me: {},
      page: new this.$constant.pageObj(),
      statelist: [],

      chs_zx: "",
      chs_rank: -1,
      chs_post: "全部岗位",
      chs_opt: "全部状态",
      chs_zstype: "全部渠道",
      chs_grade: "全部学历",
      swc: true,

      dialogVisible: false,
      excel: "",
    };
  },
  methods: {
    showResumeImg(row) {
      row.showresume = 1
      // console.log("this.users.zxs",row)
    },
    showResume() {

      api.attent2Resume({}, (res) => {
        this.list()
        this.$utils.msg.success(res.msg);
      }, err => {
        this.$utils.msg.warning("没有简历");
      });

    },
    uploadSuccess(res) {
      if (res && res.length > 5) {
        this.$utils.msg.success("上传成功!");

        let file = this.excel.substr(this.excel.lastIndexOf("/statics/excels/") + 16);
        this.$refs.uploaddist.open(file, "确认导入数据");

        this.dialogVisible = false;
      } else {
        this.$alert("上传失败", "请联系管理员。", {
          confirmButtonText: "确定",
        });
      }
    },
    handleClose() { },
    toPush() {
      //导入数据
      this.dialogVisible = true;
    },
    //获取数据
    list() {
      this.listLoading = true;
      let params = this.$utils.merger(this.searchParams, this.page);


        if (this.chs_opt != "全部状态") {
          params.type = this.chs_opt;
        }

        if (this.chs_zstype != "全部渠道") {
          params.zstype = this.chs_zstype;
        }

        if (this.chs_post != "全部岗位") {
          params.post = this.chs_post;
        }

        if (this.chs_rank != -1) {
          params.rank = this.chs_rank;
        }

        if (this.chs_zx != "全部") {
          params.zx = this.chs_zx;
        }

        if (this.isLinqi  ) {
          params.isLQ = "1";
        }

        if (this.statelist.length < 1) {
          this.loadme();
        }
     
      api.list(params, (response) => {
        this.listData = response.data;
        this.listLoading = false;
      });

    }, showConsudoc() {
      this.$refs.consudoc.open();
    },

    showEdit(zxer) {
      //已分配咨询的不允许电邀再修改
      if (this.me.role == "dy" && zxer) {
        return false;
      }

      return true;
    }, chgGradeSelect() {
      if (this.chs_grade != '全部学历') {
        this.searchParams.grade = this.chs_grade
      } else {
        delete this.searchParams.grade
      }
      this.list();
    },
   //搜索
    search() {
      this.page.current = 1
      if (
        this.searchParams.name &&
        this.searchParams.name.length > 1 &&
        this.searchParams.mobile &&
        this.searchParams.mobile.length > 1
      ) {
        api.list(
          { name: this.searchParams.name, mobile: this.searchParams.mobile },
          (response) => {
            if (response.data.records.length > 0) {
              let stu = response.data.records[0];
              let msg;
              if (stu.zxer) {
                msg =
                  "当前电邀:" +
                  stu.dyer +
                  ",咨询:" +
                  stu.zxer +
                  ",最后更新：" +
                  stu.mdtm;
              } else {
                msg =
                  "当前电邀:" + stu.dyer + ",咨询未分配,最后更新：" + stu.mdtm;
              }
              this.$alert(msg, stu.name + " 数据已存在,请检查冲突。", {
                confirmButtonText: "确定",
                callback: (action) => { },
              });
            }
          }
        );
      } else {
        this.chs_opt = "全部状态";
        this.chs_post = "全部岗位";

        if (this.me.role == "dy" || this.me.role == "dy") {
          this.chs_zx = "未分配";
        } else if (this.me.role == "zx" || this.me.role == "tr") {
          this.chs_zx = this.me.name;
        } else {
          this.chs_zx = "全部";
        }

        this.chs_zstype = "全部渠道";
        this.chs_rank = -1;
        this.list();
      }
    }, toTop() {

      if (!this.selectedDatas || this.selectedDatas.length == 0) {
        this.$utils.msg.info("请选择至少一行");
        return;
      }

      this.$utils.confirm.warning("操作提示", "是否将选中的 " + this.selectedDatas.length + " 条数据全部置顶？", () => {
        let ids = []
        this.selectedDatas.forEach(v => {
          ids.push(v.id)
        })

        api.upDatatoFront({ ids: ids }, res => {
          this.clearSearchVal()
        })
      })

    }, merge21st() {
      this.$utils.confirm.warning("操作提示", "是否将选中的 " + this.selectedDatas.length + "咨询记录合并到？" + this.selectedDatas[0].name, () => {
        let ids = [];
        this.selectedDatas.forEach(v => {
          ids.push(v.id)
        })

        api.merge2to1({ ids: ids }, res => {
          this.$utils.msg.success(res.msg);
          this.list();
        })

      })

    },
    dis2dy(msg) {
      if (!this.selectedDatas || this.selectedDatas.length == 0) {
        this.$utils.msg.info("请选择至少一行");
        return;
      }

      let ids = []
      this.selectedDatas.forEach(v => {
        ids.push(v.id)
      })
      this.$refs.d2dy.open(ids, msg);

    }, filterMine(row, index, type) {
      let rows = []
      let idx = 0;

      //计算能够循环看的下一个
      this.listData.records.forEach((v, i) => {
        if ("dy" == type) {
          if (v.dyer) {  //已分配-只能是自己的
            if (v.id == row.id) {
              index = idx
            }
            idx++;
            rows.push(v)
          }
        } else if ("zx" == type) {
          if (v.zxer) {  //已分配-只能是自己的
            if (v.id == row.id) {
              index = idx
            }
            idx++;
            rows.push(v)
          }
        }

      });
      return { idx: index, rows: rows }
    },
    phoneTo(index) {
      let row = this.listData.records[index]

      //判断是否是自己的
      if (this.me.role == "dy") {
        if (!data.dyer) {
          this.$utils.confirm.warning("操作提示", "您并不拥有该咨询量，是否分配给自己?", () => {
            let param = { ids: [row.id], uname: this.me.name, type: 1 };
            api.dspConus(
              param,
              (res) => {
                this.$utils.msg.success(res.msg);
                this.$set(row, 'dyer', this.me.name);

                let datas = this.filterMine(row, index, 'dy');

                this.$refs.advc.open(datas.rows, datas.idx, "完成电邀", this.me);
              },
              (err) => {
                this.$utils.msg.warning(err.msg);
              },
            );
          });
        } else {

          let datas = this.filterMine(row, index, 'dy');
          this.$refs.advc.open(datas.rows, datas.idx, "完成电邀", this.me);
        }

      } else {
        this.$refs.advc.open(this.listData.records, index, "完成电邀", this.me);
      }


    },
    attackTo(index) {

      if (this.me.role == "dy") {
        let row = this.listData.records[index]
        if (!row.dyer) {
          this.$utils.confirm.warning("操作提示", "您并不拥有该咨询量，是否分配给自己?", () => {
            let param = { ids: [row.id], uname: this.me.name, type: 1 };
            api.dspConus(
              param,
              res => {
                this.$utils.msg.success(res.msg);
                this.$set(row, 'dyer', this.me.name);
                let datas = this.filterMine(row, index, 'dy');
                //  console.log("datas",datas)
                this.$refs.attckone.open(datas.idx, datas.rows, this.me, this.users.zxs,  null,"取得并完成电邀");
              },
              err => {
                this.$utils.msg.warning(err.msg);
              }
            );
          });
        } else {
          let datas = this.filterMine(row, index, 'dy');
          // console.log("datas2",datas)
          this.$refs.attckone.open(datas.idx, datas.rows, this.me, this.users.zxs,  null,"完成电邀");
        }

      } else if (this.me.role == "zx") {
        let row = this.listData.records[index]
        if (!row.zxer) {
          this.$utils.confirm.warning("操作提示", "您并不拥有该咨询量，是否分配给自己?", () => {
            let param = { ids: [row.id], uname: this.me.name, type: 2 };
            api.dspConus(
              param,
              res => {
                this.$utils.msg.success(res.msg);
                this.$set(row, 'zxer', this.me.name);

                this.$refs.attckone.open(index, this.listData.records, this.me, this.users.zxs, null, "取得并完成跟进");
              },
              err => {
                this.$utils.msg.warning(err.msg);
              }
            );
          });
        } else {

          this.$refs.attckone.open(index, this.listData.records, this.me, this.users.zxs, null, "完成跟进");
        }

      } else {

        //  open(index, list, me, zxs, title, grade, disabled, size) {

        // admin + mgr 权限
        if (this.searchParams.grade == '挑低学历') {
          this.$refs.attckone.open(
            index,
            this.listData.records,
            this.me,
            this.users.zxs,
            null,
            "完成跟进",
            '挑低学历'
          );
        } else {
          this.$refs.attckone.open(
            index,
            this.listData.records,
            this.me,
            this.users.zxs,
            this.users.dys,
            "完成跟进"
          );
        }
      }

    },
    //去添加
    toSave() {
      this.$refs.edit.open(this.me, "添加咨询量");
    },
    //去编辑
    toUpdate(index, row) {
      let editParameter = {
        id: row.id,
      };
      this.$refs.edit.open(editParameter, "编辑");
    },
    //去详情
    toDetail(index) {
      this.$refs.show.open(index, this.listData.records, "详情");
    },
    //删除
    remove(index, row) {
      let parameter = {
        ids: row.id,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //批量删除
    batchRemove() {
      if (!this.selected || this.selected.length == 0) {
        this.$utils.msg.info("请选择至少一行");
        return;
      }
      let parameter = {
        ids: this.selected,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          {
            ids: this.selected,
          },
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      this.selectedDatas = [];
      for (let item of val) {
        this.selected.push(item.id);
        this.selectedDatas.push(item);
      }
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },
    calAge(brith) {
      if (brith && brith.length > 2) {
        let xx = this.now.getTime();
        let xxa = new Date(brith).getTime();
        let age = ((xx - xxa) / (86400000 * 365)).toFixed(0);
        if (age > 10 && age < 50) {
          return age + "(岁)";
        }
        return;
      }
      return "";
    },chgSelect(){

      if(this.chs_opt == "尚未联系"){
        this.clearSearchVal();
      }else{
        this.list();
      }

    },
    //清空搜索框
    clearSearchVal() {

      this.searchParams = {};
      this.chs_grade = "全部学历"
      if (this.me.role == "dy") {
        this.chs_zx = "未分配";
      } else if (this.me.role == "zx" || this.me.role == "tr") {
        this.chs_zx = this.me.name;
      } else {
        this.chs_zx = "全部";
      }
      this.chs_rank = -1
      this.chs_post = "全部岗位"

      if( this.chs_opt == "尚未联系"){
         this.searchParams.chs_opt= "尚未联系"
      }else{
         this.chs_opt = "全部状态"
      }

      this.isLinqi = false

      this.page = new this.$constant.pageObj()

      this.list();
    },
    loadme() {
      this.now = new Date();

      if (!this.$caches.users.get().zxs) {
        //加载一遍
        this.$caches.cleanCaches();
        window.location.reload();
      }

      this.me = this.$caches.user.get();

      if (this.me.role == "zx" || this.me.role == "dy") {

        if (this.me.role2 == "zx1") { //新兼职电邀只可以看自己的
            this.zxs = [{ name: this.me.name },{ name: '未分配' }];
        }else{
            this.zxs = [{ name: this.me.name },];
        }
        

        if (this.me.role2 == "dy5") { //新兼职电邀只可以看自己的
          this.chs_zx = this.me.name;
        } else if (this.me.role == "dy" || this.me.role2 == "zxm") {
          this.zxs.unshift({ name: "未分配" });
          this.chs_zx = "未分配";
        } else {
          this.chs_zx = this.me.name;
        }
        if (this.me.role == "zx") {
          this.users = this.$caches.users.get();
          if (this.me.role2 == "zxm") {
            this.zxs = this.zxs.concat(this.users.zxs).concat(this.users.dys);
          }
        }
      } else if (this.me.role == "ad" || this.me.role == "mg") {
        this.users = this.$caches.users.get();
        this.zxs = this.users.zxs.concat(this.users.dys).concat(this.users.trs);

        //this.zxs.push({id:'0000',name:'重置'})

        this.zxs.unshift({ name: "全部" });
        this.zxs.unshift({ name: "未分配" });
        this.zxs.unshift({ name: "没电邀" });
        this.chs_zx = "全部";
      }


      this.statelist = [
        '全部状态',
        '有意向',
        '可跟进',
        '意向不大',
        '无意向',
        '已上门',
        '已测评',
        '已辅助',
        '新录入',
        '已报名',
        '未接通',
        '废量'
      ];

      if (this.me.role == "ad" || this.me.role == "mg") {
        this.statelist.unshift("尚未联系");
      }

    },
  },
  mounted() {
    this.loadme();
    this.list();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>